module.exports = __webpack_public_path__ + "static/media/22355743586_55e40e4464_o.3fb336e7.jpg";